<h3 class="schema__advantage-item-title schema__advantage-item-title-dark">
  {{ 'main.schemas.handyTools' | translate }}
</h3>

<div class="schema__card schema__paragraph-regular schema__paragraph-dark">
  {{ 'main.schemas.setOfTools' | translate }}
</div>

<rp-home-coming-soon-label />
